import * as Yup from "yup";
import dateFormatter from "../utils/helpers/dateFormatter";

const GenerateLabelValidation =  Yup.object().shape({
    firstName: Yup.string()
      .required("First Name is required!")
      .max(100, "First Name must be no longer than 100 characters"),
    lastName: Yup.string()
      .required("Last Name is required!")
      .max(100, "Last Name must be no longer than 100 characters"),
    email: Yup.string().email("Email ID is invalid").required("Email ID is required!"),
    address: Yup.string()
      .required("Address is required!")
      .test(
        "no-empty-blank-space",
        "Address cannot be an empty blank space(s)",
        (value: any) => {
          return value && value.trim() !== "";
        }
      ).max(35, 'Address should not be more than 35 characters'),
    city: Yup.string()
      .required("City is required!")
      .test(
        "no-empty-blank-space",
        "City cannot be an empty blank space(s)",
        (value: any) => {
          return value && value.trim() !== "";
        }
      ),
    stateValue: Yup.string()
      .required("State is required!")
      .test(
        "no-empty-blank-space",
        "State cannot be an empty blank space(s)",
        (value: any) => {
          return value && value.trim() !== "";
        }
      ),
    zipCode: Yup.string()
      .min(5, "Zip code length must equal to 5")
      .max(5, "Zip code length must equal to 5")
      .matches(/^[0-9]+$/, "Zip code must be numbers").required('Zip Code is required!'),
    phone: Yup.string().test("phone-validation", "Phone must contain 10 digits with the following format 000-000-0000", (value) => {
      if (!value) {
        return true;
      }
      return /\d{3}-\d{3}-\d{4}/.test(value);
    }).required('Phone is required!'),
    shipmentDate: Yup.string()
      .test(
        "custom-date-validator",
        (value: string | undefined) => !!dateFormatter(value)
      )
      .required("Shipment Date is required!"),
  })

  export default GenerateLabelValidation;